/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React from 'react';

import { useHistory } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import config from './config';

import Routes from './components/Routes';

const oktaAuth = new OktaAuth(config.oidc);

function App() {
  const history = useHistory();

  // const originalUriFromPath = (window.location.search.split('original_uri=')[1] || '').split('&')[0] || null;
  
  const urlParams = new URLSearchParams(document.location.search);
  console.log("URL PARAMS: ", urlParams);
  
  //lol why this doesn't work?

  let originalUri = urlParams.get('original_uri') as any;

  if(localStorage.getItem('original_uri')) {
    originalUri = localStorage.getItem('original_uri') as any;
  }

  const orignalFullURL = window.location.protocol + '//' +window.location.host + originalUri;
  console.log('originalUriFromPath: ', orignalFullURL);


  // if (orignalFullURL) {
  //   localStorage.setItem(
  //     'original_uri',
  //     originalUri
  //   );
  // }
  const restoreOriginalUri = (_oktaAuth: any, originalUri: string) => {
    window.location.assign(orignalFullURL!);
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <div className="App">
        <main>
          <Routes />
        </main>
      </div>
    </Security>
  );
}

export default App;
